module.exports = new __parcel__URL__("slant-phrases.c4f7645e.jpg").toString();